import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49ac0c9d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "success-stories-area pb-75" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "top-title" }, "Our Recent Works"),
  /*#__PURE__*/_createElementVNode("h2", { title: "We connect brands with celebrities and influencers for powerful digital campaigns." }, "MyCelebrity is a celebrity and influencer agency that specialized in elevating brands through impactful collaborations.")
], -1))
const _hoisted_4 = {
  class: "row align-items-center",
  "data-aos": "fade-up",
  "data-aos-duration": "1200",
  "data-aos-delay": "300"
}
const _hoisted_5 = { class: "success-single-item style-two transition-y" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "success-content d-flex align-items-center justify-content-between" }
const _hoisted_8 = { title: "celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.instagramPosts, (post) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-lg-3 col-sm-6",
            key: post.id
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("iframe", {
                src: `https://www.instagram.com/p/${post.code}/embed`,
                width: "100%",
                height: "480",
                frameborder: "0",
                allowfullscreen: "",
                scrolling: "no",
                allowtransparency: "true",
                class: "instagram-frame"
              }, null, 8, _hoisted_6),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", null, [
                  _createElementVNode("h3", _hoisted_8, _toDisplayString(post.title), 1),
                  _createElementVNode("span", null, _toDisplayString(post.designation), 1)
                ])
              ])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}